export default __webpack_public_path__ + "static/media/A6.5145e947.gif";